import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const Subtitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.space.sm};
  line-height: ${({ theme }) => theme.line.height.base};

  @media print {
    display: block;
  }
  ${({ pageType }) => pageType === "classification" && `flex-direction: row;`}
  margin: ${({ theme }) => theme.space.md};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ theme }) => theme.space.lg};
  }
`;

export const SubtitleLabel = styled(Type)`
  display: inline-block;
  margin: 0 ${({ theme }) => theme.space.sm} ${({ theme }) => theme.space.sm} 0;
`;
